import axios from "axios";
import { contactUsAction } from "./contactUsAction";
import { showSuccessSnackbar } from "../../snackBar/snackBar.action";

const getAdminURL = (state) => {
  return state.environnment.environmentLists.adminBaseURL;
};

export const getAllContactUsAsync = (
  searchBy,
  searchText,
  type,
  audioType = "all",
  leadType = "all",
  callOutcomeStatus = "all",
) => {
  return async (dispatch, getState) => {
    try {
      const adminBaseURL = getAdminURL(getState());
      let { skip, limit, leadType: stateLeadType } = getState().contactUs;
      // Always use the latest leadType from Redux state to ensure correct filtering
      const finalLeadType = stateLeadType || leadType || "all";
      dispatch(contactUsAction.getAllContactStart());
      const { data } = await axios({
        method: "Get",
        url: `${process.env.REACT_APP_HOST}${adminBaseURL}/contactUs/getAll?skip=${skip}&limit=${limit}&column=${searchBy}&type=${type}&dir=&search=${searchText}&audio_type=${audioType}&lead_type=${finalLeadType}&call_outcome_status=${callOutcomeStatus}`,
        headers: {
          "Content-Type": "application/json",
        },
      });
      if (data.code === 200) {
        return dispatch(contactUsAction.getAllContactSuccess(data.data));
      }
      dispatch(contactUsAction.getAllContactError());
      return dispatch(showSuccessSnackbar("success", data.message, 3000));
    } catch (error) {
      console.log(error);
      dispatch(contactUsAction.getAllContactError());
      dispatch(showSuccessSnackbar("error", "Error while fetching data", 3000));
    }
  };
};

export const getContactUsAsync = (id) => {
  return async (dispatch, getState) => {
    try {
      const adminBaseURL = getAdminURL(getState());
      dispatch(contactUsAction.getContactStart());
      const { data } = await axios({
        method: "Get",
        url: `${process.env.REACT_APP_HOST}${adminBaseURL}/contactUs/getContectUs/${id}`,
        headers: {
          "Content-Type": "application/json",
        },
      });
      if (data.code === 200) {
        return dispatch(contactUsAction.getContactSuccess(data.data));
      }
      dispatch(contactUsAction.getContactError());
      return dispatch(showSuccessSnackbar("success", data.message, 3000));
    } catch (error) {
      console.log(error);
      dispatch(contactUsAction.getContactError());
      dispatch(showSuccessSnackbar("error", "Error while fetching data", 3000));
    }
  };
};

export const deleteContactUsAsync = (id) => {
  return async (dispatch, getState) => {
    try {
      const dataarra = [id];

      const adminBaseURL = getAdminURL(getState());
      dispatch(contactUsAction.getContactStart());
      const { data } = await axios({
        method: "post",
        url: `${process.env.REACT_APP_HOST}${adminBaseURL}/contactUs/removeMultiContactsUs/`,
        headers: {
          "Content-Type": "application/json",
        },
        data: {
          data: dataarra,
        },
      });
      console.log(id);
      if (data.code === 200) {
        return dispatch(contactUsAction.getContactSuccess(data.data));
      }
      dispatch(contactUsAction.getContactError());
      return dispatch(showSuccessSnackbar("success", data.message, 3000));
    } catch (error) {
      console.log(error);
      dispatch(contactUsAction.getContactError());
      dispatch(showSuccessSnackbar("error", "Error while fetching data", 3000));
    }
  };
};

export const deletedSelectedContactsUs = (id) => {
  return async (dispatch, getState) => {
    try {
      const idsArray = id;

      const adminBaseURL = getAdminURL(getState());
      dispatch(contactUsAction.getContactStart());
      const { data } = await axios({
        method: "post",
        url: `${process.env.REACT_APP_HOST}${adminBaseURL}/contactUs/deletedSelectedContactsUs/`,
        headers: {
          "Content-Type": "application/json",
        },
        data: {
          ids: idsArray,
        },
      });
      console.log(id);
      if (data.code === 200) {
        return dispatch(contactUsAction.getContactSuccess(data.data));
      }
      dispatch(contactUsAction.getContactError());
      return dispatch(showSuccessSnackbar("success", data.message, 3000));
    } catch (error) {
      console.log(error);
      dispatch(contactUsAction.getContactError());
      dispatch(showSuccessSnackbar("error", "Error while fetching data", 3000));
    }
  };
};

export const getContactPageNameListAsync = () => {
  return async (dispatch, getState) => {
    try {
      const adminBaseURL = getAdminURL(getState());
      dispatch(contactUsAction.getContactStart());
      const { data } = await axios({
        method: "Get",
        url: `${process.env.REACT_APP_HOST}${adminBaseURL}/contactUs/getPageNameList`,
        headers: {
          "Content-Type": "application/json",
        },
      });
      if (data.code === 200) {
        return dispatch(
          contactUsAction.getContactPageNameListSuccess(data.data),
        );
      }
    } catch (error) {
      console.log(error);
      dispatch(contactUsAction.getContactError());
      dispatch(showSuccessSnackbar("error", "Error while fetching data", 3000));
    }
  };
};

export const updateContactUsLeadTypeAsync = (id, leadType) => {
  return async (dispatch, getState) => {
    try {
      const adminBaseURL = getAdminURL(getState());
      const { data } = await axios({
        method: "POST",
        url: `${process.env.REACT_APP_HOST}${adminBaseURL}/contactUs/sendInquiry`,
        headers: {
          "Content-Type": "application/json",
        },
        data: {
          id,
          leadType,
        },
      });
      if (data.code === 200) {
        dispatch(
          showSuccessSnackbar(
            "success",
            "Lead type updated successfully",
            3000,
          ),
        );
        dispatch(contactUsAction.getContactSuccess(data.data));
        return Promise.resolve(data.data);
      }
      const errorMessage = data.message || "Error while updating lead type";
      dispatch(showSuccessSnackbar("error", errorMessage, 3000));
      return Promise.reject(new Error(errorMessage));
    } catch (error) {
      console.log(error);
      const errorMessage =
        error.response?.data?.message || "Error while updating lead type";
      dispatch(showSuccessSnackbar("error", errorMessage, 3000));
      return Promise.reject(error);
    }
  };
};

// Same backend call as updateContactUsLeadTypeAsync, but for the listing
// page: patches just that row in ContactList.records instead of replacing
// the whole ContactList with a single record (which would break the list).
export const updateContactLeadTypeInListAsync = (id, leadType) => {
  return async (dispatch, getState) => {
    try {
      const adminBaseURL = getAdminURL(getState());
      const { data } = await axios({
        method: "POST",
        url: `${process.env.REACT_APP_HOST}${adminBaseURL}/contactUs/sendInquiry`,
        headers: {
          "Content-Type": "application/json",
        },
        data: {
          id,
          leadType,
        },
      });
      if (data.code === 200) {
        dispatch(
          showSuccessSnackbar(
            "success",
            "Lead type updated successfully",
            3000,
          ),
        );
        dispatch(
          contactUsAction.updateLeadTypeInList(
            id,
            (data.data && data.data.leadType) || leadType,
          ),
        );
        return Promise.resolve(data.data);
      }
      const errorMessage = data.message || "Error while updating lead type";
      dispatch(showSuccessSnackbar("error", errorMessage, 3000));
      return Promise.reject(new Error(errorMessage));
    } catch (error) {
      console.log(error);
      const errorMessage =
        error.response?.data?.message || "Error while updating lead type";
      dispatch(showSuccessSnackbar("error", errorMessage, 3000));
      return Promise.reject(error);
    }
  };
};
